export default __webpack_public_path__ + "static/media/Logo-BlueBlack.88dec6fc.svg";